import { settleApiCall } from '../../../api/utils';
import { getPriceVariantsIds } from '../../../utils/priceVariants';
import { createFieldToEntityMap } from '../../../utils/common';
export const getPriceVariants = async _ref => {
  let {
    priceVariantsClient,
    items,
    populationLevel
  } = _ref;
  const shouldPopulatePriceVariants = populationLevel == null ? void 0 : populationLevel.priceVariants;
  if (!shouldPopulatePriceVariants) {
    return {
      data: [],
      hasError: false
    };
  }
  const itemsPriceVariantsIds = getPriceVariantsIds(items);
  if (itemsPriceVariantsIds.length > 0) {
    const priceVariantsApiResponse = await settleApiCall(() => priceVariantsClient.getBulk({
      ids: itemsPriceVariantsIds
    }));
    if (priceVariantsApiResponse.hasError) {
      return priceVariantsApiResponse;
    }
    const priceVariantsMap = createFieldToEntityMap(priceVariantsApiResponse.data.data, 'id');
    return {
      data: priceVariantsApiResponse.data.data,
      idsToEntityMap: priceVariantsMap,
      hasError: false
    };
  }
  return {
    data: [],
    hasError: false
  };
};
//# sourceMappingURL=getPriceVariants.js.map